import { callDeleteApi, callGetApi, callPostApi, callPutApi } from "../interceptor";

// Get Tenant Admin List API function
export async function getTenantAdmin(data) {
  try {
    const response = await callPostApi({ url: "tenant-admin/list", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// Add Tenant Admin API function
export async function addTenantAdmin(data) {
  try {
    const response = await callPostApi({ url: "tenant-admin/create", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// Get Tenant Admin By Id API function
export async function getTenantAdminById(id) {
  try {
    const response = await callGetApi({ url: `tenant-admin/${id}` });
    return response;
  } catch (error) {
    throw error;
  }
}

// Update Tenant Admin API function
export async function updateTenantAdmin(id, data) {
  try {
    const response = await callPutApi({ url: `tenant-admin/update/${id}`, body: data });
    return response;
  } catch (error) {
    throw error;
  }
}

// Delete Tenant Admin API function
export async function deleteTenantAdmin(id, data) {
  try {
    const response = await callPutApi({ url: `tenant-admin/delete/${id}`, body: data });
    return response;
  } catch (error) {
    throw error;
  }
}
